import { useState, useEffect, useRef } from 'react';

// Hook: Animate number counting up
export function useCountUp(target, duration = 2000, startOnView = true) {
  const [count, setCount] = useState(0);
  const [started, setStarted] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!startOnView) { setStarted(true); return; }
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !started) setStarted(true);
    }, { threshold: 0.3 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [started, startOnView]);

  useEffect(() => {
    if (!started) return;
    const num = parseInt(String(target).replace(/[^0-9]/g, ''), 10);
    if (isNaN(num) || num === 0) { setCount(0); return; }
    const steps = 40;
    const increment = num / steps;
    let current = 0;
    const timer = setInterval(() => {
      current += increment;
      if (current >= num) { setCount(num); clearInterval(timer); }
      else setCount(Math.floor(current));
    }, duration / steps);
    return () => clearInterval(timer);
  }, [started, target, duration]);

  return { count, ref };
}

// Hook: Fade-in on scroll
export function useFadeIn(threshold = 0.1) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { setVisible(true); observer.disconnect(); }
    }, { threshold });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold]);

  return { ref, visible };
}

// Hook: Time-based greeting
export function useTimeGreeting(language = 'en') {
  const hour = new Date().getHours();
  if (hour < 12) return language === 'ta' ? 'காலை வணக்கம்!' : 'Good Morning!';
  if (hour < 17) return language === 'ta' ? 'மதிய வணக்கம்!' : 'Good Afternoon!';
  return language === 'ta' ? 'மாலை வணக்கம்!' : 'Good Evening!';
}
